import type { RedoMerchantDiscountsRpcClient } from "@redotech/redo-merchant-discounts-rpc/client";
import { createRedoMerchantDiscountsRpcClient } from "@redotech/redo-merchant-discounts-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMerchantDiscountsRpcClientContext: Context<
  RedoMerchantDiscountsRpcClient | undefined
> = createContext<RedoMerchantDiscountsRpcClient | undefined>(undefined);
RedoMerchantDiscountsRpcClientContext.displayName =
  "RedoMerchantDiscountsRpcClientContext";

export function RedoMerchantDiscountsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantDiscountsRpcClient({
      baseURL: new URL(`${baseUrl}/discounts-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMerchantDiscountsRpcClientContext.Provider value={client}>
      {children}
    </RedoMerchantDiscountsRpcClientContext.Provider>
  );
}
